<script lang="ts" setup>
import EditDatePicker from "@/editor/EditDatePicker.vue";

import {
  getDateFromInput,
  getMask,
  valueToFormatStr,
  getHolidayColorVuetify,
} from "./CalenderHelper";

import { ref, useTemplateRef, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import MaskedInput from "./MaskedInput.vue";
import { useRegisterValidation } from "@/components/EditorValidator";

declare interface EditDatePickerControlProps extends EditControlProps {
  formatProp?: string;
  onFocus?: boolean;
}

declare interface EditDatePickerUiData extends EditorControlUiData {
  menuLeft: number; // = 0;
  menuTop: number; // = 0;
  showPicker: boolean; // = false;
  showField: boolean; // = true;
  inputText: string; // = "";
  mask: string; // = "D1.M1.1111";
  inputDate: Date; // = ""
  format1: string; // = "dd.MM.yyyy"; // übergabe Format und ANZEIGE Format Muss ident sein!
  format: string; // = "dd.MM.yyyy";
  inputFormat: string; // = null; // auf maske abgestimmter formatstr
  strict: boolean; // = true;
  start: string; // = "Month";
  depth: string; // = "Year";
  showLabel: boolean; // = false;
  initalized: boolean; // = false;
  iconCss?: string;

  // Datum für Picker
  currentDate?: string; // string des datums
  currentDateValue?: Date; // das echte datum

  minDate?: Date; // = ""; // auf SperrDAtum setzen
  maxDate?: Date; // = "";
  holidayDate: Holiday[]; // = []; // muss mit den Datums aus der Holiday tabelle gefüllt werden
  isFocused?: boolean;
  //errorMessages: Array<string> = [];
  text?: string;
  sperrBegriff?: string;
}

const props = defineProps<EditDatePickerControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

const { config, ui } = getDefaultEditorControlConfig<
  EditorControlConfig,
  EditDatePickerControlProps,
  EditDatePickerUiData
>(props, emitFn, {
  // default start values
  menuLeft: 0,
  menuTop: 0,
  showPicker: false,
  showField: true,
  mask: "D1.M1.1111 H1:11",
  format1: "dd.MM.yyyy HH:mm", // übergabe Format und ANZEIGE Format Muss ident sein!
  format: "dd.MM.yyyy HH:mm",
  strict: true,
  start: "Month",
  depth: "Year",
  showLabel: false,
  initalized: false,

  holidayDate: [], // muss mit den Datums aus der Holiday tabelle gefüllt werden
  errorMessages: [],
});
const uiData = reactive(ui);
const maskedControl = useTemplateRef("masked");
config.validate = validate;
useRegisterValidation({ config });

onMounted(async () => {
  mounted(uiData, props, config);
  await mountedBaseDatePicker();
});

let timeDate!: string | null;

function disabledText() {
  //      return valueToFormatStr(currentDate, uiData.format);
  if (uiData.currentDateValue) {
    return valueToFormatStr(uiData.currentDateValue, uiData.format);
  } else {
    return valueToFormatStr(uiData.data, uiData.format);
  }
}
function getDefault() {
  return new Date().toISOStringWithTZ();
}

async function mountedBaseDatePicker() {
  if (uiData.format.indexOf("EE") >= 0) {
    uiData.format = uiData.format.replace(/(EE)/g, "");
  }
  uiData.mask = getMask(uiData.format);
  uiData.currentDateValue = uiData.data;
  if (uiData.currentDateValue != null) {
    uiData.inputText = valueToFormatStr(uiData.currentDateValue, uiData.format);
  }
}
function validate() {
  try {
    if (uiData.disabled) {
      uiData.errorText = "";
      return true;
    } // disabled Controls sind IMMER valide ;)
    if (uiData.required) {
      let mydate: any = uiData.inputText || uiData.currentDate || uiData.currentDateValue;
      console.log(mydate);
      if (typeof mydate === "string") {
        const result = getDateFromInput(mydate, uiData.format);

        // getDateFromInput gibt { date: Date, error: string } zurück
        if (result.error) {
          uiData.errorText = result.error;
          return false;
        }

        mydate = result.date;
      }
      if (mydate instanceof Date && !isNaN(mydate.getTime())) {
        uiData.errorText = "";
        return true;
      }
      uiData.errorText = config.requiredMessage;
      return false;
    }
    uiData.errorText = "";
    return true;
  } catch (err) {
    console.error(err);
  }
  return false;
}

function getDateFromInputUI(input: string, format: string): Date | undefined {
  uiData.errorText = "";

  if (!input && uiData.required) {
    uiData.errorText = config.requiredMessage;
    return undefined;
  }
}
function dateChanged(d: { event: Event; element: HTMLElement }) {
  if (uiData.currentDate !== null) {
    uiData.showLabel = true;
  } else {
    uiData.showLabel = false;
  }
  try {
    if (d && d.event && d.event.type === "blur") {
      return;
    }
    let val: string = "";

    if (!uiData.inputText) {
      uiData.currentDateValue = undefined;
    } else if (typeof uiData.inputText === "string") {
      uiData.currentDateValue = getDateFromInputUI(uiData.inputText, uiData.format);
    } else if (
      typeof uiData.currentDate === "object" &&
      uiData.currentDateValue?.toISOStringWithTZ
    ) {
      uiData.currentDateValue = uiData.currentDate;
    }

    if (uiData.currentDateValue) {
      val = uiData.currentDateValue.toISOStringWithTZ();
    }
    validate();

    // uiData.currentDate = val;
    valueChanged(config, uiData, val);
  } catch (err) {
    console.error(err);
  }
}
function getHolidayColorVuetifyUI(args: string) {
  try {
    return getHolidayColorVuetify(new Date(args)) ?? "";
  } catch (err) {
    console.error(err);
  }
}
function datePicked(value: Date) {
  try {
    if (value) {
      const isodate = value.toISOStringWithTZ().substr(0, 10);
      let isodateval = "";
      let hour = 0;
      let min = 0;
      if (uiData.currentDateValue) {
        isodateval = uiData.currentDateValue.toISOStringWithTZ().substr(0, 10);
        hour = uiData.currentDateValue.getHours();
        min = uiData.currentDateValue.getMinutes();
      }

      const newDate = new Date(isodate);
      newDate.setHours(hour);
      newDate.setMinutes(min);
      uiData.inputText = valueToFormatStr(newDate, uiData.format);
      uiData.showPicker = false;
      validate();
      valueChanged(config, uiData, newDate.toISOStringWithTZ());
    }
  } catch (err) {
    console.error(err);
  }
}

function clickAppend() {
  uiData.showPicker = !uiData.showPicker;
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <div v-if="uiData.disabled" v-bind="props">{{ disabledText() }}</div>

        <div v-bind="props">
          <MaskedInput
            append-inner-icon="mdi-calendar"
            ref="masked"
            :required="uiData.required"
            :label="description"
            :placeholder="uiData.format"
            :mask="uiData.mask"
            v-model="uiData.inputText"
            @update:modelValue="dateChanged"
            @appendClick="clickAppend"
            :errorText="uiData.errorText"
            id="textfield"
            v-if="uiData.showField && !uiData.disabled"
            append-sync-icon="mdi-clock-outline"
            :autofocus="autofocus"
          />
          <ValueChangeTracker
            v-if="uiData.isChanged || props.disableValueChangeTracker"
          />
        </div>

        <v-menu
          v-model="uiData.showPicker"
          :close-on-content-click="false"
          activator="parent"
        >
          <div style="background: white">
            <v-date-picker
              v-model="uiData.currentDateValue"
              locale="de-de"
              :min="uiData.minDate"
              range
              first-day-of-week="1"
              :show-week="true"
              @update:model-value="datePicked"
            ></v-date-picker>
          </div>
        </v-menu>
      </template>
    </v-tooltip>
  </div>
</template>

<style lang="css">
.ontheTop {
  background-color: white;
  backface-visibility: hidden;
  visibility: visible;
  max-height: 400px;
  z-index: 1001;
}
</style>
